import styled from 'styled-components';

export const Container = styled.section`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding: 20px;
`;

export const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 16px;
  padding-bottom: 16px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 16px;

  h1 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
  }

  .button {
    width: fit-content;
    display: flex;
    padding: 8px 16px;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 32px;
    border: 1px solid ${({ theme }) => theme.colors.grey.white};

    span {
      margin-bottom: -2px;
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }
`;

export const Model = styled.div`
  width: 100%;
  padding: 8px;
  gap: 12px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey.white};
  border-radius: 100px;

  img {
    width: 100%;
    max-width: 60px;
    height: 60px;
    border-radius: 100%;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: ${({ theme }) => theme.colors.grey.black};

    span {
      display: flex;
      align-items: center;
      gap: 4px;

      svg {
        margin-top: -4px;
      }
    }
  }

  &:hover {
    transition: 0.7s;
    opacity: 0.8;
  }
`;

export const Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;

  > div {
    width: 100%;
    max-width: 210px;
    height: 210px;
  }
`;
